import { FC } from 'react';
import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
import { ColorName } from '@shinetools/sunshine';

import useFeatureFlagsSwitcher from '../../../../../common/hooks/useFeatureFlagsSwitcher';
import Heading from '../../../../../components/_core/Heading';
import SunshineCard from '../../../../../components/_core/SunshineCard';
import SunshineTag from '../../../../../components/_core/SunshineTag';
import {
  ALL_FEATURE_FLAGS,
  FeatureFlagsEnv,
  FeatureFlagsKey,
} from '../../../../../featureFlags';
import locales from '../locales';

const ENV_STATUSES_TO_HIGHLIGHT: [FeatureFlagsEnv, ColorName][] = [
  ['development', 'yellow'],
  ['staging', 'orange'],
  ['production', 'blue'],
];

type FeatureFlagsSectionProps = {
  flagsKeys: FeatureFlagsKey[];
  title: string;
};

export const FeatureFlagsSection: FC<FeatureFlagsSectionProps> = ({
  flagsKeys,
  title,
}) => {
  const { featureFlags, toggleFeatureFlag } = useFeatureFlagsSwitcher();

  return (
    <Box marginBottom="space-48" marginTop="space-16">
      <Heading paddingBottom="space-24">{title}</Heading>
      <SimpleGrid columns={{ '3xl': 3, sm: 2 }} spacing="space-24">
        {flagsKeys.map((flagKey) => (
          <SunshineCard
            isChecked={featureFlags[flagKey]}
            key={flagKey}
            onChange={() => toggleFeatureFlag(flagKey)}
            size="lg"
            title={locales.features[flagKey].title}
            variant="checkbox"
          >
            <SunshineCard.Text>
              {locales.features[flagKey].subtitle}
            </SunshineCard.Text>

            <Flex
              flexDirection="row"
              gap="space-4"
              justifyContent="flex-start"
              marginTop="space-8"
            >
              {ENV_STATUSES_TO_HIGHLIGHT.map(([env, colorScheme]) =>
                ALL_FEATURE_FLAGS[env][flagKey] ? (
                  <SunshineTag colorScheme={colorScheme} key={env} size="sm">
                    {env}
                  </SunshineTag>
                ) : null,
              )}
            </Flex>
          </SunshineCard>
        ))}
      </SimpleGrid>
    </Box>
  );
};
